"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedProvider = exports.ScopedProviderContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const jotai_1 = require("jotai");
const react_1 = require("react");
__exportStar(require("./hooks"), exports);
exports.ScopedProviderContext = (0, react_1.createContext)(new Map());
/**
 * a simple provider for reading atoms from children inside React DOM tree
 * support inheritance and SAME_LEVEL atom computing.
 */
const ScopedProvider = (props) => {
    const { atomsWithHydration = [], atoms = [], children } = props;
    const scopedStore = (0, react_1.useMemo)(jotai_1.createStore, []);
    const parentScopedContext = (0, react_1.useContext)(exports.ScopedProviderContext);
    const scopedContextValue = (0, react_1.useMemo)(() => {
        const map = new Map(parentScopedContext);
        atomsWithHydration.forEach(([atom, data]) => {
            map.set(atom, scopedStore);
            scopedStore.set(atom, data);
        });
        atoms.forEach((atom) => {
            map.set(atom, scopedStore);
        });
        return map;
    }, [scopedStore, parentScopedContext]);
    atomsWithHydration.forEach(([atom, data]) => {
        (0, react_1.useEffect)(() => {
            scopedStore.set(atom, data);
        }, [data]);
    });
    return (0, jsx_runtime_1.jsx)(exports.ScopedProviderContext.Provider, { value: scopedContextValue, children: children });
};
exports.ScopedProvider = ScopedProvider;
